import Tabs from './Tabs';
import TabItem from './TabItem';

export {
  Tabs, TabItem,
};



// WEBPACK FOOTER //
// ./src/components/tab/index.js